import { render, staticRenderFns } from "./AggregateFAQ.vue?vue&type=template&id=2fc2d1fe&scoped=true&"
import script from "./AggregateFAQ.vue?vue&type=script&lang=js&"
export * from "./AggregateFAQ.vue?vue&type=script&lang=js&"
import style0 from "./AggregateFAQ.vue?vue&type=style&index=0&id=2fc2d1fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc2d1fe",
  null
  
)

export default component.exports